import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { usePlanFeature } from "hooks";
import Modal from "components/Modal";

import { useInsightsLicenseAction } from "./hooks";
import { InsightsUpgradeModal } from "./components";

export function InsightsConfirmationModal({ user, onComplete, onClose }) {
  const { loading, eligibility, error } = usePlanFeature("insights", {
    showToasterOnError: false,
  });

  const { isSubmitting, enableUserInsights } =
    useInsightsLicenseAction(onComplete);

  const getModalBody = () => {
    if (error) {
      return error;
    }

    if (user.insightsEnabled) {
      return "Do you want to disable insights capabilities for this user?";
    }

    if (eligibility?.eligible) {
      return (
        <React.Fragment>
          {eligibility?.cause && (
            <React.Fragment>
              <span>{eligibility?.cause}</span>
              <br />
            </React.Fragment>
          )}
          <span>
            Do you want to enable insights capabilities for this user?
          </span>
        </React.Fragment>
      );
    }

    return eligibility?.cause;
  };

  if (eligibility && !eligibility.eligible && !user.insightsEnabled)
    return (
      <InsightsUpgradeModal
        message={eligibility.cause}
        onClose={onClose}
        email={user.email}
      />
    );

  return (
    <Modal
      style={{ maxWidth: "400px" }}
      isModalOpen
      isLoading={loading}
      data-test="insights-confirmation-modal"
      onClose={onClose}
    >
      <Modal.Header disabled={isSubmitting} onClose={onClose}>
        <span data-test="insights-confirmation-modal-header">
          {user.insightsEnabled ? "Disable" : "Enable"} Insights: {user.name}
        </span>
      </Modal.Header>
      <Modal.Body data-test="insights-confirmation-modal-body">
        {getModalBody()}
      </Modal.Body>
      <Modal.Footer>
        <Button
          basic
          data-test="insights-confirmation-modal-cancel-btn"
          content="Cancel"
          disabled={isSubmitting}
          onClick={onClose}
        />
        {(eligibility?.eligible || user?.insightsEnabled) && (
          <Button
            primary
            data-test="insights-confirmation-modal-action-btn"
            content={user?.insightsEnabled ? "Disable" : "Enable"}
            loading={isSubmitting}
            disabled={isSubmitting}
            onClick={() => {
              enableUserInsights(user, !user.insightsEnabled);
            }}
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}

InsightsConfirmationModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    insightsEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InsightsConfirmationModal;
